/**
 * Minimal full-pitch line art for lineup tab (vector, no raster background).
 */

import React from 'react';
import Svg, { Ellipse, Line, Rect } from 'react-native-svg';
import {
  LINEUP_PITCH_FRAME_WIDTH_OVER_HEIGHT,
  LINEUP_PITCH_STRIPE_LIGHT,
  LINEUP_PITCH_STRIPE_DARK,
  LINEUP_PITCH_STRIPE_COUNT,
} from './lineupPitchLayout.constants';

export interface LineupPitchFieldProps {
  lineColor: string;
  fillColor: string;
  midLineColor: string;
}

const STROKE_MAIN = 0.6;
const STROKE_FINE = 0.5;
/** Vertical semi-axis in viewBox units; horizontal axis derived so the ring looks circular on the pitch frame. */
const CENTER_CIRCLE_RY = 15.5;
const CENTER_CIRCLE_RX = CENTER_CIRCLE_RY / LINEUP_PITCH_FRAME_WIDTH_OVER_HEIGHT;
const STRIPE_W = 100 / LINEUP_PITCH_STRIPE_COUNT;

export const LineupPitchField: React.FC<LineupPitchFieldProps> = ({ lineColor, fillColor, midLineColor }) => (
  <Svg width="100%" height="100%" viewBox="0 0 100 100" preserveAspectRatio="none">
    <Rect x={0} y={0} width={100} height={100} fill={fillColor} />
    {Array.from({ length: LINEUP_PITCH_STRIPE_COUNT }, (_, i) => (
      <Rect
        key={i}
        x={i * STRIPE_W}
        y={0}
        width={STRIPE_W}
        height={100}
        fill={i % 2 === 0 ? LINEUP_PITCH_STRIPE_LIGHT : LINEUP_PITCH_STRIPE_DARK}
      />
    ))}
    <Rect x={0.25} y={0.25} width={99.5} height={99.5} fill="none" stroke={lineColor} strokeWidth={STROKE_MAIN} />
    <Line x1={0} y1={50} x2={100} y2={50} stroke={midLineColor} strokeWidth={STROKE_MAIN} />
    <Ellipse
      cx={50}
      cy={50}
      rx={CENTER_CIRCLE_RX}
      ry={CENTER_CIRCLE_RY}
      fill="none"
      stroke={lineColor}
      strokeWidth={STROKE_MAIN}
    />
    <Rect x={18} y={0.25} width={64} height={17.5} fill="none" stroke={lineColor} strokeWidth={STROKE_FINE} />
    <Rect x={34} y={0.25} width={32} height={6} fill="none" stroke={lineColor} strokeWidth={STROKE_FINE} />
    <Rect x={18} y={82.25} width={64} height={17.5} fill="none" stroke={lineColor} strokeWidth={STROKE_FINE} />
    <Rect x={34} y={93.25} width={32} height={6} fill="none" stroke={lineColor} strokeWidth={STROKE_FINE} />
  </Svg>
);
